import React from 'react';
import ReactDOM from 'react-dom';
import PropTypes from 'prop-types';

export default class Portal extends React.PureComponent {
    constructor(props) {
        super(props);
        this.portalsRoot = document.createElement('div');
        document.body.appendChild(this.portalsRoot);
        this.el = document.createElement('div');
    }

    componentDidMount() {
        this.portalsRoot.appendChild(this.el);
    }

    componentWillUnmount() {
        this.portalsRoot.removeChild(this.el);
    }

    render() {
        return ReactDOM.createPortal(
            this.props.children,
            this.el
        );
    }
}

Portal.propTypes = {
    children: PropTypes.node.isRequired
};
